import React from "react";

export default function useReloadOnBack() {
    React.useEffect(() => {
        window.history.pushState(null, "", window.location.href);

        const handlePopState = () => {
            window.location.reload();
        };

        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, []);
}
